const blank = (props) => props.children;

export default blank;